import { TagType, TaskClosingCode } from '../../types/interfaces';
import IApiCalls from '../api/interfaces/apiCalls';

import BaseService from './BaseService';
import IClosingCodesService from './interfaces/ClosingCodesService';
import ServiceResult from './interfaces/ServiceResult';

class ClosingCodesService
  extends BaseService<TaskClosingCode>
  implements IClosingCodesService
{
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'ClosingCodes');
  }

  restore(id: number): ServiceResult<void> {
    const apiCalls = this._apiCalls.beginApiCalls();
    return {
      result: apiCalls.ClosingCodes.restore(id),
      cancel: apiCalls.cancelAllCalls
    };
  }

  getByStatus(statusId: number): ServiceResult<TaskClosingCode[] | undefined> {
    const apiCalls = this._apiCalls.beginApiCalls();
    return {
      result: apiCalls.ClosingCodes.getByStatus(statusId),
      cancel: apiCalls.cancelAllCalls
    };
  }

  getForSelection(): ServiceResult<TagType[] | undefined> {
    const apiCalls = this._apiCalls.beginApiCalls();
    return {
      result: apiCalls.ClosingCodes.getForSelection(),
      cancel: apiCalls.cancelAllCalls
    };
  }

  addOrUpdateWithError(model: TaskClosingCode): {
    result: Promise<number | string | undefined>;
    cancel: () => void;
  } {
    const apiCalls = this._apiCalls.beginApiCalls();
    const api = apiCalls.ClosingCodes;
    return {
      result: api.addOrUpdateWithError(model),
      cancel: apiCalls.cancelAllCalls
    };
  }
}

export default ClosingCodesService;
